import React from "react";

import { UIProps } from "components/base/types";
import Box from "ui-box";

export const Span = (props: UIProps) => <Box is="span" {...props} />;

export default Span;
